/** This file can be deleted entirely once dependencies in web-components & shipping-status are removed */
const AU_STATES = [
    { code: 'NSW', name: 'New South Wales' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'WA', name: 'Western Australia' },
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NT', name: 'Northern Territory' },
];
const AE_COUNTRIES = [
    { name: 'United Arab Emirates', alpha2: 'AE' },
    { name: 'Qatar', alpha2: 'QA' },
];
const CA_PROVINCES = [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' },
];
const NZ_PROVINCES = [
    { code: 'AUK', name: 'Auckland' },
    { code: 'BOP', name: 'Bay of Plenty' },
    { code: 'CAN', name: 'Canterbury' },
    { code: 'GIS', name: 'Gisborne' },
    { code: 'HKB', name: "Hawke's Bay" },
    { code: 'MWT', name: 'Manawatu-Wanganui' },
    { code: 'MBH', name: 'Marlborough' },
    { code: 'NSN', name: 'Nelson' },
    { code: 'NTL', name: 'Northland' },
    { code: 'OTA', name: 'Otago' },
    { code: 'STL', name: 'Southland' },
    { code: 'TKI', name: 'Taranaki' },
    { code: 'TAS', name: 'Tasman' },
    { code: 'WKO', name: 'Waikato' },
    { code: 'WGN', name: 'Wellington' },
    { code: 'WTC', name: 'West Coast' },
];
const US_STATES = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
    { code: 'AA', name: 'Armed Americas' },
    { code: 'AE', name: 'Armed Europe' },
    { code: 'AP', name: 'Armed Pacific' },
];
const AU_COUNTRIES = [{ name: 'Australia', alpha2: 'AU' }];
const CA_COUNTRIES = [{ name: 'Canada', alpha2: 'CA' }];
const EU_COUNTRIES = [
    { name: 'Austria', alpha2: 'AT' },
    { name: 'Belgium', alpha2: 'BE' },
    { name: 'Bulgaria', alpha2: 'BG' },
    { name: 'Croatia', alpha2: 'HR' },
    { name: 'Czech Republic', alpha2: 'CZ' },
    { name: 'Denmark', alpha2: 'DK' },
    { name: 'Estonia', alpha2: 'EE' },
    { name: 'Finland', alpha2: 'FI' },
    { name: 'France', alpha2: 'FR' },
    { name: 'Germany', alpha2: 'DE' },
    { name: 'Greece', alpha2: 'GR' },
    { name: 'Hungary', alpha2: 'HU' },
    { name: 'Ireland', alpha2: 'IE' },
    { name: 'Italy', alpha2: 'IT' },
    { name: 'Iceland', alpha2: 'IS' },
    { name: 'Latvia', alpha2: 'LV' },
    { name: 'Lithuania', alpha2: 'LT' },
    { name: 'Luxembourg', alpha2: 'LU' },
    { name: 'Monaco', alpha2: 'MC' },
    { name: 'Netherlands', alpha2: 'NL' },
    { name: 'Norway', alpha2: 'NO' },
    { name: 'Poland', alpha2: 'PL' },
    { name: 'Portugal', alpha2: 'PT' },
    { name: 'Romania', alpha2: 'RO' },
    { name: 'Slovakia', alpha2: 'SK' },
    { name: 'Slovenia', alpha2: 'SI' },
    { name: 'Spain', alpha2: 'ES' },
    { name: 'Sweden', alpha2: 'SE' },
    { name: 'Switzerland', alpha2: 'CH' },
];
const UK_COUNTRIES = [{ name: 'United Kingdom', alpha2: 'GB' }];
const US_COUNTRIES = [{ name: 'United States', alpha2: 'US' }];
const NZ_COUNTRIES = [{ name: 'New Zealand', alpha2: 'NZ' }];
/* eslint-disable id-length */
/**
 * @deprecated Use SUPPORTED_COUNTRIES instead
 */
export const COUNTRIES_BY_REGION = {
    US: US_COUNTRIES,
    AU: AU_COUNTRIES,
    EU: EU_COUNTRIES,
    AE: AE_COUNTRIES,
    UK: UK_COUNTRIES,
    CA: CA_COUNTRIES,
    NZ: NZ_COUNTRIES,
};
/**
 * @deprecated Use STATES_BY_COUNTRY instead
 */
export const STATES_BY_REGION = {
    US: US_STATES,
    AU: AU_STATES,
    CA: CA_PROVINCES,
    NZ: NZ_PROVINCES,
};
/* eslint-enable id-length */
